import moment from "moment";

// Temps a la colla = dies des del primer esdeveniment al qual la persona va venir.
// Colors de càlid (novells) a fred (veterans), prou diferents entre veïns.
export const TEMPS_BUCKETS = [
    { key: 'novells', label: 'Menys de 3 mesos', short: '< 3 mesos', maxDays: 91, color: '#eda100' },
    { key: 'mesos', label: '3 a 12 mesos', short: '3–12 mesos', maxDays: 365, color: '#e87ba4' },
    { key: 'any1', label: '1 a 2 anys', short: '1–2 anys', maxDays: 730, color: '#1baf7a' },
    { key: 'any2', label: '2 a 3 anys', short: '2–3 anys', maxDays: 1095, color: '#2a78d6' },
    { key: 'any3', label: '3 anys o més', short: '3+ anys', maxDays: Infinity, color: '#4a3aa7' },
];

export const bucketIndex = days => TEMPS_BUCKETS.findIndex(bucket => days < bucket.maxDays);

export const daysInColla = (firstDate, atDate) =>
    Math.max(0, moment(atDate).diff(moment(firstDate), 'days'));

const isCountedCasteller = (info, filters) => {
    if (!info) return false;
    if (filters?.canalla && info.canalla === 1) return false;
    if (filters?.music && info.music === 1) return false;
    return true;
};

// Persones de cada franja a un esdeveniment, amb el temps que portaven a la colla aquell dia.
export const eventComposition = (event, { firstAttendance, attendees }, castellersInfo, filters) => {
    const counts = TEMPS_BUCKETS.map(() => 0);
    (attendees[event.id] || [])
        .filter(user => firstAttendance[user])
        .filter(user => isCountedCasteller(castellersInfo[user], filters))
        .forEach(user => {
            counts[bucketIndex(daysInColla(firstAttendance[user], event['data-esperada-inici']))] += 1;
        });
    return counts;
};

// Abans del primer esdeveniment amb assistència, tothom "comença" aquí.
export const firstDataDate = firstAttendance => {
    const dates = Object.values(firstAttendance);
    if (dates.length === 0) return null;
    return dates.reduce((min, d) => (moment(d).isBefore(min) ? d : min), dates[0]);
};
